module.exports = __webpack_public_path__ + "static/media/check.05aa243f.svg";